module.exports = __webpack_public_path__ + "img/Body_DiffuseColor.41f0a10.png";